import React, { Component } from "react";
import { Button, Form, Icon, Input, message, Modal, Select, Switch, Table, Tag } from "antd";
import {
  createUserApi,
  fetchUsersApi,
  updateUserPasswordApi,
  updateUserRoleApi,
  updateUserStatusApi
} from "../../common/api";
import "./style.scss";

const ROLE_LABELS = {
  admin: "管理员",
  viewer: "查看者"
};

class AccountManagement extends Component {
  state = {
    users: [],
    loading: false,
    createVisible: false,
    createSubmitting: false,
    passwordVisible: false,
    passwordSubmitting: false,
    selectedUser: null,
    createForm: {
      username: "",
      password: "",
      role: "viewer",
      enabled: true
    },
    passwordForm: {
      password: ""
    }
  };

  componentDidMount() {
    this.loadUsers();
  }

  render() {
    const { loading, users, createVisible, createSubmitting, passwordVisible, passwordSubmitting, createForm, passwordForm, selectedUser } = this.state;
    return (
      <div className="account-management">
        <div className="account-toolbar">
          <div className="account-title">账号管理</div>
          <Button type="primary" onClick={this.openCreateModal}>
            <Icon type="user-add" />
            新增账号
          </Button>
        </div>
        <Table
          rowKey="id"
          loading={loading}
          dataSource={users}
          columns={this.columns()}
          pagination={false}
        />
        <Modal
          title="新增账号"
          visible={createVisible}
          confirmLoading={createSubmitting}
          onCancel={this.closeCreateModal}
          onOk={this.createUser}
          okText="保存"
          cancelText="取消"
        >
          <Form layout="vertical">
            <Form.Item label="用户名">
              <Input value={createForm.username} onChange={this.handleCreateChange("username")} />
            </Form.Item>
            <Form.Item label="密码">
              <Input.Password value={createForm.password} onChange={this.handleCreateChange("password")} />
            </Form.Item>
            <Form.Item label="角色">
              <Select value={createForm.role} onChange={this.handleCreateSelect("role")}>
                <Select.Option value="viewer">查看者</Select.Option>
                <Select.Option value="admin">管理员</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="启用">
              <Switch checked={createForm.enabled} onChange={this.handleCreateSelect("enabled")} />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title={selectedUser ? `重置密码：${selectedUser.username}` : "重置密码"}
          visible={passwordVisible}
          confirmLoading={passwordSubmitting}
          onCancel={this.closePasswordModal}
          onOk={this.resetPassword}
          okText="保存"
          cancelText="取消"
        >
          <Form layout="vertical">
            <Form.Item label="新密码">
              <Input.Password value={passwordForm.password} onChange={this.handlePasswordChange} />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  columns = () => {
    const currentUserId = this.props.currentUser && this.props.currentUser.userId;
    return [
      {
        title: "用户名",
        dataIndex: "username",
        key: "username"
      },
      {
        title: "角色",
        dataIndex: "role",
        key: "role",
        render: (role, record) => (
          <Select
            size="small"
            value={role}
            disabled={record.id === currentUserId}
            onChange={nextRole => this.updateRole(record, nextRole)}
            className="account-role-select"
          >
            <Select.Option value="viewer">查看者</Select.Option>
            <Select.Option value="admin">管理员</Select.Option>
          </Select>
        )
      },
      {
        title: "状态",
        dataIndex: "enabled",
        key: "enabled",
        render: (enabled, record) => (
          <Switch
            checked={enabled}
            disabled={record.id === currentUserId}
            onChange={checked => this.updateStatus(record, checked)}
          />
        )
      },
      {
        title: "最近登录",
        dataIndex: "lastLoginAt",
        key: "lastLoginAt",
        render: value => this.formatTime(value)
      },
      {
        title: "创建时间",
        dataIndex: "createdAt",
        key: "createdAt",
        render: value => this.formatTime(value)
      },
      {
        title: "标记",
        key: "tag",
        render: (_, record) => (
          <Tag color={record.role === "admin" ? "blue" : "default"}>
            {ROLE_LABELS[record.role] || record.role}
          </Tag>
        )
      },
      {
        title: "操作",
        key: "actions",
        render: (_, record) => (
          <Button size="small" onClick={() => this.openPasswordModal(record)}>
            <Icon type="key" />
            重置密码
          </Button>
        )
      }
    ];
  };

  loadUsers = () => {
    this.setState({
      loading: true
    });
    fetchUsersApi()
      .then(users => {
        this.setState({
          users: users || [],
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          loading: false
        });
      });
  };

  openCreateModal = () => {
    this.setState({
      createVisible: true,
      createForm: {
        username: "",
        password: "",
        role: "viewer",
        enabled: true
      }
    });
  };

  closeCreateModal = () => {
    this.setState({
      createVisible: false
    });
  };

  handleCreateChange = key => event => {
    this.setState({
      createForm: {
        ...this.state.createForm,
        [key]: event.target.value
      }
    });
  };

  handleCreateSelect = key => value => {
    this.setState({
      createForm: {
        ...this.state.createForm,
        [key]: value
      }
    });
  };

  createUser = () => {
    const { createForm } = this.state;
    this.setState({
      createSubmitting: true
    });
    createUserApi(createForm)
      .then(() => {
        message.success("账号已创建");
        this.setState({
          createSubmitting: false,
          createVisible: false
        });
        this.loadUsers();
      })
      .catch(() => {
        this.setState({
          createSubmitting: false
        });
      });
  };

  updateStatus = (record, enabled) => {
    updateUserStatusApi(record.id, enabled)
      .then(() => {
        message.success("状态已更新");
        this.loadUsers();
      })
      .catch(() => {
        this.loadUsers();
      });
  };

  updateRole = (record, role) => {
    updateUserRoleApi(record.id, role)
      .then(() => {
        message.success("角色已更新");
        this.loadUsers();
      })
      .catch(() => {
        this.loadUsers();
      });
  };

  openPasswordModal = selectedUser => {
    this.setState({
      selectedUser,
      passwordVisible: true,
      passwordForm: {
        password: ""
      }
    });
  };

  closePasswordModal = () => {
    this.setState({
      passwordVisible: false,
      selectedUser: null
    });
  };

  handlePasswordChange = event => {
    this.setState({
      passwordForm: {
        password: event.target.value
      }
    });
  };

  resetPassword = () => {
    const { selectedUser, passwordForm } = this.state;
    if (!selectedUser) {
      return;
    }
    this.setState({
      passwordSubmitting: true
    });
    updateUserPasswordApi(selectedUser.id, passwordForm.password)
      .then(() => {
        message.success("密码已更新");
        this.setState({
          passwordSubmitting: false,
          passwordVisible: false,
          selectedUser: null
        });
      })
      .catch(() => {
        this.setState({
          passwordSubmitting: false
        });
      });
  };

  formatTime = value => {
    if (!value) {
      return "-";
    }
    const date = new Date(value);
    const pad = number => String(number).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };
}

export default AccountManagement;
